export default __webpack_public_path__ + "static/media/logo2.352a1b08.png";